// extracted by mini-css-extract-plugin
export default {"order_details":"order-details_order_details__zy4vN","order_identifier":"order-details_order_identifier__qsBu7","done":"order-details_done__0FpdC"};